require('../modules/esnext.math.iaddh');
require('../modules/esnext.math.isubh');
require('../modules/esnext.math.imulh');
require('../modules/esnext.math.umulh');



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/proposals/efficient-64-bit-arithmetic.js
// module id = B6kf
// module chunks = 0